import React, { useEffect, useState } from "react";
import { Table } from "antd";
import { BiEdit } from "react-icons/bi";
import { AiFillDelete } from "react-icons/ai";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { deleteAAssociation, getAssociations, resetState } from "../features/association/associationSlice";
import CustomModal from "../components/CustomModal";

const columns = [
  {
    title: "SNo",
    dataIndex: "key",
  },
  {
    title: "Name",
    dataIndex: "name",
  },
  {
    title: "Short Name",
    dataIndex: "shortName",
  },
  {
    title: "Email",
    dataIndex: "email",
  },
  {
    title: "Type",
    dataIndex: "type",
  },
  {
    title: "Logo",
    dataIndex: "logo",
    render: logo => <img src={logo} alt="Association Logo" style={{ width: 50, height: 50 }} />,
  },
  {
    title: "Action",
    dataIndex: "action",
  },
];

const Associationlist = () => {
  const [open, setOpen] = useState(false);
  const [AssociationId, setAssociationId] = useState("");
  const showModal = (e) => {
    setOpen(true);
    setAssociationId(e);
  };

  const hideModal = () => {
    setOpen(false);
  };
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(resetState());
    dispatch(getAssociations());
  }, []);
  const getAssociationState = useSelector((state) => state.association.Associations);
  console.log(getAssociationState);
  const data1 = [];
  console.log(getAssociationState.length);
  for (let i = 0; i < getAssociationState.length; i++) {
    data1.push({
      key: i + 1,
      name: getAssociationState[i].name,
      shortName: getAssociationState[i].shortName,
      email: getAssociationState[i].email,
      type: getAssociationState[i].type,
      logo: getAssociationState[i].image,

      action: (
        <>
          <Link
            to={`/admin/Add-Association/${getAssociationState[i]._id}`}
            className=" fs-3 text-danger"
          >
            <BiEdit />
          </Link>
          <button
            className="ms-3 fs-3 text-danger bg-transparent border-0"
            onClick={() => showModal(getAssociationState[i]._id)}
          >
            <AiFillDelete />
          </button>
        </>
      ),
    });
  }
  const deleteNews = (e) => {
    dispatch(deleteAAssociation(e));

    setOpen(false);
    setTimeout(() => {
      dispatch(getAssociations());
    }, 100);
  };
  return (
    <div>
      <h3 className="mb-4 title">Association List</h3>
      <div>
        <Table columns={columns} dataSource={data1} />
      </div>
      <CustomModal
        hideModal={hideModal}
        open={open}
        performAction={() => {
          deleteNews(AssociationId);
        }}
        title="Are you sure you want to delete this Association?"
      />
    </div>
  );
};

export default Associationlist;
